//firebase.js
import firebase from "firebase/app";
import "firebase/firestore";

var firebaseConfig = {
    apiKey: "AIzaSyBYxsk7N84CjMtwe4IQM1oUUWlh5RNx7AU",
    authDomain: "scc-react.firebaseapp.com",
    projectId: "scc-react",
    storageBucket: "scc-react.appspot.com",
    messagingSenderId: "119249253524",
    appId: "1:119249253524:web:e2795a5227d53f767a7081",
    measurementId: "G-2XKJ41WKV0"
  };

// firebaseConfig 정보로 firebase 시작
firebase.initializeApp(firebaseConfig);

// firebase의 firestore 인스턴스를 변수에 저장
const firestore = firebase.firestore();

// 필요한 곳에서 사용할 수 있도록 내보내기
export { firestore };